module.exports = __webpack_public_path__ + "media/svg/er-04bcc2d3.svg";